export var PRODUCT_STATUS = {
  LOADING: 'loading',
  NO_STATUS: 'no_status',
  CURRENT_PRODUCT: 'current_product',
  CAN_ACTIVATE: 'can_activate',
  ACCESS_NEEDED: 'access_needed',
  CAN_SWITCH: 'can_switch'
};
export function generateInitialProductsStatus(currentProduct) {
  var initialProductsStatus = generateStatusForAllProducts(PRODUCT_STATUS.LOADING);
  initialProductsStatus[currentProduct] = PRODUCT_STATUS.CURRENT_PRODUCT;
  return initialProductsStatus;
}
export function generateStatusForAllProducts(status) {
  return {
    appoptics: status,
    pingdom: status,
    papertrail: status,
    loggly: status
  };
}